import { NgModule } from '@angular/core';
import { RouterModule, Routes, RouterLink, RouterLinkActive } from '@angular/router';
import { LobMaintenanceComponent } from './lob-maintenance/lob-maintenance.component';
import { FundMaintenanceComponent } from './capital-demand/fund-maintenance/fund-maintenance.component';
import { EnterpriseInitiativesComponent } from './enterprise-initiatives/enterprise-initiatives.component';
import { ForecastManagementComponent } from './forecast-management/forecast-management.component';
import { ForecastManagementServiceDetailComponent } from './forecast-management/forecast-management-service-detail/forecast-management-service-detail.component';
import { BulkMaintenanceComponent } from './bulk-maintenance/bulk-maintenance.component';
import { UCMGListViewComponent } from './capital-demand/ucmg-list-view/ucmg-list-view.component';
import { RulesEngineComponent } from './rules-engine/rules-engine.component';
import { GroupMaintenanceComponent } from './group-maintenance/group-maintenance.component';
import { CreateGroupComponent } from './group-maintenance/create-group/create-group.component';
import { EditGroupComponent } from './group-maintenance/edit-group/edit-group.component';
import { ViewGroupComponent } from './group-maintenance/view-group/view-group.component';

const routes: Routes = [
    { path: '', component: LobMaintenanceComponent },
    { path: 'group', component: GroupMaintenanceComponent },
    { path: 'createGroup', component: CreateGroupComponent },
    { path: 'editGroup', component: EditGroupComponent },
    { path: 'viewGroup', component: ViewGroupComponent },
    { path: 'Capital-Demand', component: FundMaintenanceComponent },
    { path: 'Capital-Demand/UCMG-List-View', component: UCMGListViewComponent},
    { path: 'initiatives', component: EnterpriseInitiativesComponent },
    { path: 'forecast-management', component: ForecastManagementComponent },
    { path: 'forecast-service', component:ForecastManagementServiceDetailComponent },
    { path: 'forecast-management/search', component: ForecastManagementComponent },
    { path: 'bulk', component: BulkMaintenanceComponent },
    {path:'rules-engine', component: RulesEngineComponent}

];

@NgModule({
    exports: [RouterModule, RouterLink, RouterLinkActive],
    imports: [RouterModule.forChild(routes)]
})
export class MaintenanceRoutingModule { }